/**
 * Home's sheets as history entries (`/#moments`, `/#legend`), so the phone's Back closes them.
 *
 * - `hashOpen(hash)`: whether home's URL names the sheet.
 * - `openHash(hash, key)`: pushes the entry (marked with `key` in its state) and tells the page, unless it is open.
 * - `closeHash(key)`: goes back when the entry was pushed here, else drops the hash from a URL opened straight (the
 *   caller closes its sheet itself: that path fires no popstate).
 */
export const hashOpen = (hash: string) => location.pathname === '/' && location.hash === hash;

export function openHash(hash: string, key: string) {
  if (hashOpen(hash)) return;
  history.pushState({ [key]: true }, '', `/${hash}`);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function closeHash(key: string) {
  if ((history.state as Record<string, unknown> | null)?.[key]) history.back();
  else history.replaceState(null, '', '/');
}

/**
 * Focus back to what opened a sheet, once home has lifted `inert` off its bar and dock: that happens in a
 * MutationObserver on <html>'s classes, whose microtask is queued before this one.
 */
export function focusBack(el: HTMLElement | null) {
  queueMicrotask(() => {
    if (el?.isConnected) el.focus();
  });
}
